import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ClearingCompany } from 'src/app/core/models/clearing-company';
import { generalRoutes } from 'src/app/core/routes/general-routes-list';
import { AlertService } from 'src/app/core/services/alert.service';
import { ClearingCompanyService } from 'src/app/core/services/general/clearing-company.service';
import { ToastService } from 'src/app/core/services/toast-service.service';
@Component({
  selector: 'app-create-clearing-company-modal',
  templateUrl: './create-clearing-company-modal.component.html',
  styleUrls: ['./create-clearing-company-modal.component.scss'],
})
export class CreateClearingCompanyModalComponent {
  public form!: FormGroup;
  public showValidationErrors = false;
  public loading = false;

  public routes = generalRoutes;

  constructor(
    private activeOffcanvas: NgbActiveOffcanvas,
    public fb: FormBuilder,
    private router: Router,
    private clearingCompanyService: ClearingCompanyService,
    private alertService: AlertService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', []],
      contact_person_name: ['', []],
      address: ['', []],
      country: ['', []],
      email: ['', [Validators.email]],
      phone_number: ['', []],
      status: ['ACTIVE', [Validators.required]],
    });
  }


  public save() {
    if (this.loading) {
      return;
    }

    if (!this.form.valid) {
      this.toastService.showError(
        'Please, fill up all required form fields.',
        'Validation Error'
      );
      this.showValidationErrors = true;
      return;
    }

    const formData = new FormData();
    formData.append('name', this.form.get('name')?.value ?? '');
    formData.append('description', this.form.get('description')?.value ?? '');
    formData.append('contact_person_name', this.form.get('contact_person_name')?.value ?? '');
    formData.append('address', this.form.get('address')?.value ?? '');
    formData.append('country', this.form.get('country')?.value ?? '');
    formData.append('email', this.form.get('email')?.value ?? '');
    formData.append('phone_number', this.form.get('phone_number')?.value ?? '');
    formData.append('status', this.form.get('status')?.value ?? '');

    this.loading = true;
    this.clearingCompanyService.store(formData).subscribe({
      next: (res: ClearingCompany) => {
        this.toastService.showSuccess(
          `Clearing Company has been added successfully.`
        );
        localStorage.setItem('created-clearing-company', JSON.stringify(res));
        this.activeOffcanvas.close(res);
      },
      error: (err: any) => {
        this.loading = false;
        this.alertService.showNotificationForHttpError(err);
      },
    });
  }
}
